var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-box",
    {
      staticClass: "flex-1",
      attrs: { title: _vm.$t("refusalCodesTitle"), hasPadding: "" },
    },
    [
      [
        _c(
          "dash-card-content-fallback",
          { attrs: { hasData: _vm.hasData } },
          _vm._l(_vm.refuseReasons, function (item, index) {
            return _c(
              "dash-progress-bar",
              {
                key: item.key + "" + index,
                attrs: { value: item.percentage, color: item.color },
              },
              [
                _c("refusal-codes-icons", {
                  attrs: {
                    "data-icon": item.leftIcon,
                    "tooltip-id": "acquirer_info-tippy-left" + item.key,
                  },
                }),
                _c("jade-text", [_vm._v(_vm._s(_vm.$t(item.name)))]),
                _c("refusal-codes-icons", {
                  attrs: {
                    "data-icon": item.rightIcon,
                    "tooltip-id": "acquirer_info-tippy-right" + item.key,
                  },
                }),
              ],
              1
            )
          }),
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }